import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class AddConsolidatedEntryService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get BLs with all units pending duty entry
   */
  getBLPendingEntry(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/add-consolidated-entry/get-bls`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Save entry
   */
  addEntry(entry_data:any,entry_attachment:any,pmt_slip_attachment:any,bl_no:any):Observable<any>{
    const formData = new FormData();
    formData.append("bl_no", bl_no);
    formData.append("entry_no", entry_data.entry_no);
    formData.append("entry_date", entry_data.entry_date);
    formData.append("duty_amount", entry_data.duty_amount);
    formData.append("doc_ref_no", entry_data.doc_ref_no);
    formData.append("payment_ref_no", entry_data.payment_ref_no);
    formData.append('entry_attachment', entry_attachment);
    formData.append('pmt_slip_attachment', pmt_slip_attachment);
    formData.append("has_rad", entry_data.has_rad ? '1' : '0');
    formData.append("has_idf", entry_data.has_idf ? '1' : '0');

    let apiURL:string=`${this.baseURL}/v1/add-consolidated-entry`;

    return this.http.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }
}
